import { render, staticRenderFns } from "./ManualScoreEntry.vue?vue&type=template&id=54c8c9a0&scoped=true"
import script from "./ManualScoreEntry.vue?vue&type=script&lang=js"
export * from "./ManualScoreEntry.vue?vue&type=script&lang=js"
import style0 from "./ManualScoreEntry.vue?vue&type=style&index=0&id=54c8c9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8c9a0",
  null
  
)

export default component.exports